import React from 'react'
import Pill from './Pill'

type MetaBoxProps = {
  label: React.ReactNode
  value?: string | string[] | null
  multi?: boolean
}

export const MetaBox: React.FC<MetaBoxProps> = ({ label, value, multi = true }) => {
  const isEmpty = (v: any) => v === null || v === undefined || v === '' || (Array.isArray(v) && v.length === 0)

  if (multi && Array.isArray(value)) {
    if (value.length === 0) {
      return (
        <div className="bg-gray-50 px-3 py-2 rounded-lg border h-full flex-1 min-w-[180px]">
          <p className="text-xs text-gray-500 mb-2">{label}</p>
          <p className="text-sm font-medium text-gray-900">—</p>
        </div>
      )
    }
    return (
      <div className="bg-gray-50 px-3 py-2 rounded-lg border h-full flex-1 min-w-[180px]">
        <p className="text-xs text-gray-500 mb-2">{label}</p>
        <div className="flex flex-wrap gap-1">
          {(value as string[]).map((val, idx) => (
            <Pill key={`${val}-${idx}`}>{val}</Pill>
          ))}
        </div>
      </div>
    )
  }

  const display = Array.isArray(value) ? (value as string[]).join(', ') : String(value || '—')
  return (
    <div className="bg-gray-50 px-3 py-2 rounded-lg border h-full flex-1 min-w-[180px]">
      <p className="text-xs text-gray-500 mb-2">{label}</p>
      <p className="text-sm font-medium text-gray-900">{isEmpty(value) ? '—' : display}</p>
    </div>
  )
}

export default MetaBox
